<nav class="navbar navbar-expand-lg navbar-light bg-white navbar-custom fixed-top px-4 py-2">
    <div class="container-fluid">
        <!-- Hamburger Button -->
        <button class="navbar-toggler me-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu"
            aria-controls="mobileMenu">
            <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Left: Western Logo -->
        <a class="navbar-brand d-flex align-items-center" style="cursor: pointer;" (click)="dashbardRoute()">

<!-- 
            <img src="images/Cavender.png" *ngIf="userInfo?.group === 'CAV1'" class="img-fluid" alt="Cavender Group"> -->
      
                <img src="images/WesternLogo.svg" *ngIf="userInfo?.group === 'WESTERN'" class="img-fluid" alt="Western Group">


                  <img src="images/DealerLogos/Hooli.svg" *ngIf="userInfo?.group === 'Hooli'" class="img-fluid" alt="Western Group">

                    <img src="images/DealerLogos/Mossy_Logo.png" *ngIf="userInfo?.group === 'MOSSY'"  class="img-fluid" alt="Mossy Group">

                        <img src="images/DealerLogos/Tropical_Logo.png" *ngIf="userInfo?.group === 'TPG'"  class="img-fluid" alt="Tropical Group">

                    <img src="images/DealerLogos/FB_Logo.png" *ngIf="userInfo?.group === 'FREDBEANS'" class="img-fluid" alt="Fredbeans Group">

                       <!--  <img src="images/DealerLogos/Price_Logo.png" *ngIf="userInfo?.group === 'PRICE'" class="img-fluid" alt="Cavender Group">

                            <img src="images/DealerLogos/Dream_Logo.png" *ngIf="userInfo?.group === 'DMG1'"  class="img-fluid" alt="Cavender Group">



                            <img src="images/DealesLogor/Western_Logo.svg"  *ngIf="userInfo?.group == undefined" class="img-fluid" alt="Western Auto Group"> -->


            <div class="line d-none d-lg-block"></div>
            <p class="d-none d-lg-block">{{componentData.title}}</p>
        </a>



        <!-- Right: Axel Logo (always visible) -->
        <img src="images/Axel One_dark.svg" alt="AXEL ONE" class="axel-logo ms-auto d-none">

        <div class="collapse navbar-collapse d-none d-lg-flex justify-content-end align-items-center">
            <div class="nav-icons d-flex align-items-center">

                <div class="d-flex justify-content-center align-items-center">
                    <app-riv-icon *ngIf="!notificationService?.nCount" src="images/riv/bell.riv" stateMachine="State Machine 1" [width]="24" [height]="24" (click)="onNotificationIconClick()"></app-riv-icon>

                    <app-riv-icon *ngIf="notificationService?.nCount"  src="images/riv/bell_unread.riv" stateMachine="State Machine 1" [width]="24" [height]="24" (click)="onNotificationIconClick()"></app-riv-icon>

                    <app-riv-icon src="images/riv/settings.riv" stateMachine="State Machine 1" [width]="26" [height]="26"></app-riv-icon>

                    <app-riv-icon *ngIf="userNetworkInfo.networkStatus" src="images/riv/vpn.riv" stateMachine="State Machine 1" [width]="26" [height]="26" ></app-riv-icon>

                    <app-riv-icon *ngIf="!userNetworkInfo.networkStatus" src="images/riv/vpn_disconnected.riv" stateMachine="State Machine 1" [width]="26" [height]="26" ></app-riv-icon>

                    <img src="images/Logout.svg" class="img-fluid" alt="" (click)="logoutSession()" title="Logout">
                </div>

                <!-- <img *ngIf="!notificationService?.nCount" src="images/Notif_icon.svg" class="img-fluid" alt=""
                    data-bs-toggle="offcanvas" data-bs-target="#notif"  (click)="onNotificationIconClick()">

                <img *ngIf="notificationService?.nCount" src="images/Notif_unread.svg" class="img-fluid" alt=""
                    data-bs-toggle="offcanvas" data-bs-target="#notif"  (click)="onNotificationIconClick()">

                <img src="images/setting.svg" class="img-fluid" alt="">
                <img src="images/Logout.svg" class="img-fluid" alt="" (click)="logoutSession()" title="Logout">

                <img src="images/Wifi.svg" class="img-fluid" alt="" *ngIf="userNetworkInfo.networkStatus"  title='Dealer Network'>
                <img src="images/Wifi_off.svg" class="img-fluid" alt="" *ngIf="!userNetworkInfo.networkStatus" title="Public Network">  -->

              <!-- <i class="img-fluid"
                    [class]="'bi ' + (userNetworkInfo.networkStatus ? 'bi-wifi text-success' : 'bi-wifi text-danger')"
                    style="font-size: 1.5rem;margin-right: 20px;"
                    [title]="userNetworkInfo.networkStatus ? 'Dealer Network' : 'Public Network'"></i>  -->


            </div>

            <div class="user-info">
                <h4>Welcome</h4>
                <p>{{userInfo?.fullName}},

                    <span *ngIf="userInfo?.user_Info?.title != 'Super Admin'">{{userInfo?.user_Info?.title}}</span>

                    <span class="dropdown" *ngIf="userInfo?.user_Info?.title == 'Super Admin'">
                        <a routerLink="#" class="dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false" >
                             {{userInfo?.user_Info?.title}} 
                            
                            <img src="images/ArrowDown.svg" alt="">
                        </a>
                        <ul class="dropdown-menu dropdown-menu-dark">
                            <li *ngFor="let dealer of ceoLogs; let i = index">
                                <span class="dropdown-item" (click)="onDealerSelect(dealer, i, $event)"> {{ (dealer?.group == 'TPG' ? 'TROPICAL' : dealer?.group ) }}</span>
                            </li>

                        </ul>
                    </span>
                </p>
            </div>

            <img src="images/Axel One_dark.svg" alt="AXEL ONE" class="axel-logo d-none d-lg-block">
        </div>
        <!-- Slide Menu for Mobile -->
        <div class="offcanvas offcanvas-start d-block d-lg-none" tabindex="-1" id="mobileMenu">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title">AXEL ONE DASHBOARD</h5>
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
            </div>
            <div class="offcanvas-body h-100">
                <div class="nav-icons d-flex mb-4">
                    <img src="images/Notif_icon.svg" class="img-fluid me-2" alt="">
                    <img src="images/setting.svg" class="img-fluid me-2" alt="">
                    <img src="images/Logout.svg" class="img-fluid me-2" alt="">
                </div>
                <div class="user-info">
                    <h4>Welcome</h4>
                    <p>{{userInfo?.fullName}},

                         <span *ngIf="userInfo?.user_Info?.title != 'Super Admin'">{{userInfo?.user_Info?.title}}</span>

                        <span class="dropdown" *ngIf="userInfo?.user_Info?.title == 'Super Admin'">
                        <a routerLink="#" class="dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false" >
                            {{userInfo?.user_Info?.title}} <img src="images/ArrowDown.svg" alt="">
                        </a>
                        <ul class="dropdown-menu dropdown-menu-dark">
                            <li *ngFor="let dealer of ceoLogs; let i = index">
                                <span class="dropdown-item" (click)="onDealerSelect(dealer, i, $event)"> {{ (dealer?.group == 'TPG' ? 'Tropical' : dealer?.group ) }}</span>
                            </li>

                        </ul>
                    </span>
                    </p>
                </div>
                <img src="images/Axel One_dark.svg" alt="AXEL ONE" class="axel-logo mt-3">
            </div>
        </div>
    </div>
</nav>


<div *ngIf="loading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
